import ImagePicker from './image-picker';

export default ImagePicker;
